import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { createLogger } from '../../utils/logger';

const logger = createLogger('notifyEmployees');

export const EMPLOYEE_NOTIFICATION_FUNCTION_URL =
  process.env.REACT_APP_EMPLOYEE_NOTIFICATION_FUNCTION_URL ||
  'https://us-central1-[REDACTED].cloudfunctions.net/notifyEmployeesNewOrderHttp';

export function isEmployeeNotificationEnabled() {
  const flag = process.env.REACT_APP_ENABLE_EMPLOYEE_NOTIFICATIONS;
  if (flag === 'false' || flag === '0') return false;
  if (flag === 'true' || flag === '1') return true;
  return true;
}

/**
 * Resolve customer display name from Users collection.
 * @param {string} userIdentityId
 */
export async function resolveCustomerNameForNotification(userIdentityId, fallback = 'Customer') {
  if (!userIdentityId) return fallback;
  try {
    const userQuery = query(
      collection(db, 'Users'),
      where('identity_id', '==', userIdentityId),
      limit(1)
    );
    const userSnap = await getDocs(userQuery);
    if (!userSnap.empty) {
      const ud = userSnap.docs[0].data();
      return ud.first_name || ud.displayName || fallback;
    }
  } catch (e) {
    logger.warn('[notifyEmployees] Failed to fetch customer name:', e);
  }
  return fallback;
}

/**
 * Fire-and-forget HTTP notification to packing staff.
 */
export function notifyEmployeesNewOrder({
  orderId,
  transactionId,
  customerName,
  supermarketId,
  logContext = 'notifyEmployees',
}) {
  if (!isEmployeeNotificationEnabled()) {
    logger.debug(`[${logContext}] Employee notifications disabled`);
    return Promise.resolve(null);
  }

  return fetch(EMPLOYEE_NOTIFICATION_FUNCTION_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      orderId,
      transactionId,
      customerName,
      supermarketId,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        logger.warn(`[${logContext}] Employee notification HTTP ${response.status}`);
        return null;
      }
      return response.json();
    })
    .then((result) => {
      if (result && result.success === false) {
        logger.warn(`[${logContext}] Employee notification returned success: false`, result);
      }
      return result;
    })
    .catch((err) => {
      logger.warn(`[${logContext}] Employee notification failed:`, err);
      return null;
    });
}
